import React from 'react';
import { useDispatch } from 'react-redux';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { Link } from 'react-router-dom';
import hidePopupOperation from 'store/app/operation/hidePopupOperation';
import { setCategoryIdAction } from 'store/category/slice';
import showBackdropOperation from 'store/app/operation/showBackdropOperation';

export interface OwnProps {
  categories: AppBundle.Api.Response.CategoryPage.V1.CategoryPageGetV1Response.ISidebarItem[];
  level: number;
}

const CategoryList = ({ categories, level }: OwnProps) => {
  const linkStyles = level > 1 ? { paddingLeft: level * 10 } : undefined;
  const dispatch = useDispatch();
  const navigateToTheCategory = (categoryId: number) => {
    dispatch(setCategoryIdAction(categoryId));
    // TODO: reset filters, page number
    dispatch(showBackdropOperation(false));
    dispatch(hidePopupOperation());
  };

  return (
    <ul>
      {categories.map((item, index) => (
        <React.Fragment key={`ci_${level}_${index}_${item.categoryId}`}>
          <li>
            <Link to={item.url} style={linkStyles} onClick={() => navigateToTheCategory(item.categoryId)}>
              {item.text}
            </Link>
          </li>
          {item.childItems && item.childItems.length > 0 && (
            <li>
              <CategoryList level={level + 1} categories={item.childItems} />
            </li>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
};

export default CategoryList;
